
export const environment = {
      production: true,
      ACCOUNT_DOCK_PUBLIC_KEY: 'ad_acco_u61tcr598hqljyxb',
      API_URL: 'https://api-staging.prepforce.io',
      APP_URL: 'https://app-staging.prepforce.io',
      CONSOLE_URL: 'https://labs-staging.xplenty.com/services/pig/evaluate',
      NODE_ENV: 'staging',
      PUSHER_PUBLIC_KEY: 'ddcc3b4354b94bd5a690',
      SEGMENT_PUBLIC_KEY: 'DF0wuWxKOr6Tb46Nqnyhrf5RaYUkzgGO',
      STRIPE_PUBLIC_KEY: 'pk_test_lGDzBx7kQrJCT71kElzaRXp1',
      PIPEDRIVE_URL: 'https://gateway-staging.xplenty.com/send-pipedrive-leads',
      PIPEDRIVE_RETURN_URL: 'https://www-staging.xplenty.com/calendly/',
      SENTRY_ENV: 'staging',
      SOURCE_VERSION: '9ffb79abceca667f25cdfa6ea76793fb8e7efe25',
      INTEGRATEIO_URL: 'https://dashboard-staging.prepforce.io',
      TESTS_FILTER: 'undefined',
      SENTRY_DSN: 'https://75f7d6ae3fb2e8095ed958bc47413e82@o4507576419680256.ingest.us.sentry.io/4507803100577792',
      SENTRY_ENABLED: false,
      HUBSPOT_URL: 'https://gateway-staging.xplenty.com/send-hubspot-leads',
};
